import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomService } from '../../_service/custom.service';
@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit {

    contactForm:FormGroup;
    submitform : boolean = false;

    show_successmsg : boolean = false;
    msg : any;
    show_errormsg : boolean = false;
    constructor(
        private fb : FormBuilder,
        public api : CustomService,
    ) {

    }

    ngOnInit() {

        this.contactForm = this.fb.group({
            full_name : ['',Validators.required],
            phone : ['',Validators.required],
            email : ['',[Validators.required,Validators.email]],
            subject : [''],
            message : [''],
        });

    }

    get f(){
        return this.contactForm.controls;
    }

    contact(){
        this.submitform = true;
        if(this.contactForm.invalid){
            return false;
        }else{
            this.api.contactus(this.contactForm.value).subscribe(
                (data:any)=>{
                    this.show_successmsg = true;
                    this.show_errormsg = false;
                    this.msg = data.msg;
                    this.contactForm.reset();
                    this.submitform = false;
                },(errors:any)=>{
                    this.show_successmsg = false;
                    this.show_errormsg = true;
                    this.msg = errors.error;
                }
            );

        }
    }

}
